import { Button, Col, EditableInfoComponent, Row } from 'components';
import { useParams } from 'react-router-dom';
import { useCompetitorsListQuery } from 'api';
import { ExpandableBrandList } from 'feature/supplierTabs/general/competitorSupplier/expandableBrandList';
import { AllCompetitorDrawer } from 'feature/supplierTabs/general/competitorSupplier/allCompetitorDrawer';
import React from 'react';
import { useCompetitorSupplier } from './useCompetitorSupplier';

export const CompetitorSupplier = () => {
  const { id } = useParams() as { id: string };
  const { data = [] } = useCompetitorsListQuery({ id });
  const { drawerState, onExpand, competitorSupplierData, onRouteChange } = useCompetitorSupplier();
  return (
    <Row>
      <EditableInfoComponent title={'Competitor Suppliers'} editable={false} />
      <Row gutter={[0, 27]}>
        {data?.map((_supplier: any) => {
          return (
            <Col key={_supplier.supplierId} span={24}>
              <Row gutter={[0, 8]}>
                <Col span={24}>
                  <Button
                    type={'link'}
                    variant={'link'}
                    style={{
                      color: '#222530',
                      textDecoration: 'underline',
                      padding: 0,
                      margin: 0,
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                    onClick={() => onRouteChange(_supplier.supplierId)}
                  >
                    {_supplier.supplierName}
                  </Button>
                </Col>
                <Col>
                  <ExpandableBrandList
                    brands={_supplier.brands}
                    supplierName={_supplier.supplierName}
                    supplierId={_supplier.supplierId}
                    onExpand={onExpand}
                  />
                </Col>
              </Row>
            </Col>
          );
        })}
      </Row>
      <AllCompetitorDrawer drawerState={drawerState} onExpand={onExpand} data={competitorSupplierData} />
    </Row>
  );
};
